var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_470_2248)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 69,
    height: 70,
    rx: 34.5,
    fill: "#223F9E",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_2248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2664 32.4501L40.4769 24.7081C39.4212 23.6249 37.997 23.0158 36.5119 23.0125C35.0268 23.0093 33.6001 23.612 32.54 24.6906L24.7325 32.4501C24.1864 32.9955 23.7517 33.6492 23.4541 34.3723C23.1564 35.0954 23.002 35.8732 23 36.6594V45.1668C23.0018 46.7133 23.595 48.196 24.6495 49.2895C25.704 50.3831 27.1337 50.9983 28.625 51.0001H44.375C45.8663 50.9983 47.296 50.3831 48.3505 49.2895C49.405 48.196 49.9982 46.7133 50 45.1668V36.6594C49.998 35.8731 49.8435 35.0952 49.5457 34.3721C49.2479 33.6489 48.8128 32.9953 48.2664 32.4501ZM34.1139 26.3578C34.7518 25.7021 35.6146 25.3358 36.5127 25.3393C37.4109 25.3428 38.271 25.7158 38.9041 26.3764L46.4945 33.9178L38.8861 41.8091C38.243 42.4449 37.3885 42.7996 36.5 42.7996C35.6115 42.7996 34.757 42.4449 34.1139 41.8091L26.5044 33.9178L34.1139 26.3578ZM47.75 45.1668C47.75 46.095 47.3944 46.9853 46.7615 47.6417C46.1286 48.298 45.2701 48.6668 44.375 48.6668H28.625C27.7299 48.6668 26.8714 48.298 26.2385 47.6417C25.6056 46.9853 25.25 46.095 25.25 45.1668V36.6594C25.2511 36.433 25.2734 36.2072 25.3164 35.9851L32.5231 43.4588C33.5814 44.5456 35.0106 45.1552 36.5 45.1552C37.9894 45.1552 39.4186 44.5456 40.4769 43.4588L47.6836 35.9851C47.7266 36.2072 47.7489 36.433 47.75 36.6594V45.1668Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_470_2248",
    x: 0,
    y: 0,
    width: 77,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.515609 0 0 0 0 0.515609 0 0 0 0 0.515609 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_470_2248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_470_2248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_2248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.ad5fef45ed29cb2d2cf54ca8d993de3d.svg";
export { ForwardRef as ReactComponent };